import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { SearchInput } from "@similarweb/ui-components";

import { SearchContainer } from "app/pages/conversion/conversionTableContainer/StyledComponents";
import { swSettings } from "app/common/services/swSettings";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { useTranslation } from "pro-features/components/WithTranslation";

import { useCategoriesComparison } from "../../categories-context";

const TableTopDivider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${colorsPalettes.carbon[100]};
`;

// We disabled the border-top (that is defined in the searchContainer styled component)
// since it has a bug that has to do with box-sizing and elements it contains
// instead of using border-top, we simply use the TableTopDivider (defined above)
// to create an effect of a border.
export const TableTopContainer = styled(SearchContainer)`
    border-top: 0 none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .SearchInput-container {
        width: 100%;

        > div:first-child {
            top: 13px;
        }

        > .SearchInput {
            height: 48px;
        }
    }
`;

const ExcelButtonContainer = styled.div`
    margin-right: 16px;
`;

interface ITableSearchAndDownloadHeaderProps {
    searchValue?: string;
    onSearch: (value: string) => void;
    downloadUrl?: string;
    showExcelDownload?: boolean;
    excelLocked?: boolean;
    searchDebounce?: number;
}

export const TableSearchAndDownloadHeader = ({
    searchValue = "",
    onSearch,
    downloadUrl,
    showExcelDownload = true,
    excelLocked,
    searchDebounce = 100,
}: ITableSearchAndDownloadHeaderProps) => {
    const t = useTranslation();
    const { isPrimaryMode } = useCategoriesComparison();
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const isExcelLocked = excelLocked ?? !downloadExcelPermitted;

    return (
        <>
            {isPrimaryMode ? <TableTopDivider /> : null}
            <TableTopContainer>
                <SearchInput
                    defaultValue={searchValue}
                    debounce={searchDebounce}
                    onChange={onSearch}
                    placeholder={t("industry.analysis.geography.table.search.placeholder")}
                    disableClear={true}
                />
                {showExcelDownload && downloadUrl ? (
                    <ExcelButtonContainer>
                        <DownloadButtonMenu
                            Excel={true}
                            downloadUrl={downloadUrl}
                            excelLocked={isExcelLocked}
                        />
                    </ExcelButtonContainer>
                ) : null}
            </TableTopContainer>
        </>
    );
};
